export const woonenergieExpandableTokens = {
  expandableIndicatorBackground: '{{ brandSupport.lightLime }}',
  expandableDefaultIndicatorColor: '{{ iconColors.iconPrimary }}',
  expandableTransparentIndicatorColor: '{{ iconColors.iconPrimary }}',
};
